<abc-file-uploader
  [invalidFileExtensionMessage]="this.res?.get('MediaSelection_InvalidFileExtensionMessage')"
  [labelText]="this.res?.get('MediaSelection_ButtonInfo')"
  [name]="'files[]'"
  [readyToUploadMessage]="this.res?.get('MediaSelection_ReadyForUpload')"
  [selectButtonText]="this.res?.get('MediaSelection_Button')"
  [uploadMode]="'useForm'"
  [uploadUrl]="'/'"
  [validationStatus]="'valid'"
  (onValueChanged)="this.selectedFiles = $event.value"
  [multiple]="true"
  [height]="'56px'"
  [accept]="this.accept"
>
</abc-file-uploader>

<div style="margin: 0 10px; padding-left: 12px; padding-bottom: 12px; font-size: smaller">
  {{ this.res?.get('MediaSelection_FileSelectedText') }} {{ selectedFiles.length }}
</div>

<div class="media-selection-buttons">
  <abc-button
    [id]="'button-Ok'"
    [stylingMode]="'outlined'"
    [text]="this.res?.get('Button_Ok')"
    class="media-selection-button"
    (click)="this.onFilesSelected.emit(this.selectedFiles)"
    [disabled]="selectedFiles.length === 0"
  >
  </abc-button>
  <abc-button
    [id]="'button-Cancel'"
    [stylingMode]="'outlined'"
    [text]="this.res?.get('Button_Cancel')"
    class="media-selection-button"
    (click)="this.onCloseDemand.emit()"
  >
  </abc-button>
</div>
